
// export const baseURL= "http://192.168.29.250:7001/api/"
// export const adminBaseURL= "http://192.168.29.250:7001/"

export const baseURL= "https://hospital-service.swasthyakhata.com/api/"
export const adminBaseURL= "https://hospital-service.swasthyakhata.com"


export const auth={
    checkUserByAdhaar:baseURL+'hospital/checkUserByAadhaar',
    sendOtp:baseURL+'hospital/send-otp',
    loginDoctor:baseURL+'hospital/login',
    createDoctor:baseURL+'hospital/create',
    getProfile:baseURL+"hospital/get-hospital-profile"
}

export const patient={
    checkMap:baseURL+'hospital/patient-mapping-check',
    getmappedPatient:baseURL+'hospital/get-mapped-patient',
    patientMappingOtpSend:baseURL+'hospital/send-otp-for-patient-mapping',
    createMappingVerify:baseURL+'hospital/create-patient-mapping',
    uploadReport:baseURL+'doctor/upload-report-by-doctor'
}

export const doctor={
    getAllRequestFromDoctor:baseURL+'hospital/doctor-request-to-hospital-for-mapping/requests',
    getAllDoctors:baseURL+'hospital/get-all-doctors-for-hospital',
    requestToDoctorMapping:baseURL+'hospital/hospital-doctor-mapping/request',
    actionRequestOfDoctors:baseURL+'hospital/doctor-hospital-mapping/',
    ownRequestToDoctor:baseURL+'hospital/hospital-own-mapping/requests-for-all-doctors'
}

export const diagnostic={
    getallDiagnostics:baseURL+'hospital/get-all-diagnostic-centers-for-hospital',
    requestToDiagnosticMapping:baseURL+'hospital/hospital-diagnostic-center-mapping/request'
}